import React from 'react';
import { Row, Col, Label, Collapse , Button } from "reactstrap";
import { Link } from "react-router-dom";
import { IconeSetaDescer, IconeSetaSubir } from '../../../comum/components/Icones';
import { formatNullableValue } from '../../../../utils/formatar';
import NumberFormat from 'react-number-format';
import { calendarFormat } from 'moment';


export default class CardBooking extends React.Component {

    constructor(props) {
        super(props);
        this.handleCapacidadeClick = this.handleCapacidadeClick.bind(this);
        this.handleContainerClick = this.handleContainerClick.bind(this);

        this.state = {capacidade: false, container: false}
    }

    handleCapacidadeClick(){
        this.setState(state => ({ capacidade: !state.capacidade}));
        if(this.state.capacidade){
            document.getElementById("icon-capacidade-fechar" + this.props.id).hidden = true;
            document.getElementById("icon-capacidade-abrir" + this.props.id).hidden = false;
        }else{
            document.getElementById("icon-capacidade-abrir" + this.props.id).hidden = true;
            document.getElementById("icon-capacidade-fechar" + this.props.id).hidden = false;
        }
    }

    handleContainerClick(){
        this.setState(state => ({ container: !state.container}));
        if(this.state.container){
            document.getElementById("icon-container-fechar" + this.props.id).hidden = true;
            document.getElementById("icon-container-abrir" + this.props.id).hidden = false;
        }else{
            document.getElementById("icon-container-abrir" + this.props.id).hidden = true;
            document.getElementById("icon-container-fechar" + this.props.id).hidden = false;
        }
    }
    
    render() {

        return (

            <Col xs={12} md={6} lg={4} onClick={ this.handleClick }>
                
                <div className="card-booking tabela">                
                
                    <Row>
                        <Col xs={12}>
                            <div className="titulo">
                                <Label className="titulo-principal">{ this.props.titulo.split('.').reduce((o,i)=>o[i], this.props.data)}</Label>
                                
                                {/* <Label className="subtitulo">{ this.props.data.Viagem }</Label> */}
                            </div>
                        </Col>

                        {this.props.colunas.map((col, x) =>
                        (col.dataField !== this.props.titulo) &&
                        (col.dataField !== "booking.Status") &&

                        ((col.dataField === "itens") ?
                            <Col xs={6} key={x}>
                                <div className="info bg-cinza">                              
                                    <div className="titulo">{col.text }</div>
                                    <div className="valor">{
                                        formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data),null,null,col.formatExtraData))
                                    }</div>
                                </div>
                            </Col>
                            :
                            
                            <Col xs={6} key={x}>
                                <div className="info bg-cinza">
                               
                                    <div className="titulo">{col.text}</div>
                                    <div className="valor">{ col.formatter ?
                                        (col.dataField === "booking.VesselName" ?
                                        formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data),this.props.data,null,col.formatExtraData))
                                        :
                                        formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data)))
                                        )
                                        
                                        :
                                        col.dataField.split('.').reduce((o,i)=>o[i], this.props.data)
                                    }</div>
                                </div>
                            </Col>
                        ))}

                        <Col xs={12}>
                            <div className="info">
                                <div className={`situacao-btn ${ this.props.data.booking.Status.toLowerCase() }`}>{ this.props.data.booking.Status }</div>
                                {/* {col.formatter("booking.Status".split('.').reduce((o,i)=>o[i], this.props.data))} */}
                            </div>
                        </Col>

                        <Col xs={12}>
                            <div className="area-colapsada">
                                <Button className="btn" onClick={this.handleCapacidadeClick}  >
                                Capacidade
                                    <span id={`icon-capacidade-abrir${ this.props.id }`}><IconeSetaDescer /></span>
                                    <span id={`icon-capacidade-fechar${ this.props.id }`} hidden ><IconeSetaSubir /></span>
                                </Button>
                                
                                <Collapse  isOpen={this.state.capacidade}>
                                    <Row>
                                    {this.props.capacidade.map((col, x) =>
                                        <Col key={x} xs={col.tamanhoCol > 2 ? 12 : 6} className="">
                                            <div className="card-detalhe">
                                                <div>
                                                    <h5>{col.titulo}</h5>
                                                    {/* <div className="desc">{col.field}</div> */}
                                                    <div className="desc">{ col.formatacao ?
                                                        col.formatacao(this.props.data.itens[0][col.field])    
                                                        :
                                                        this.props.data.itens[0][col.field] 
                                                    }</div>

                                                </div>
                                                
                                            </div>
                                        </Col>

                                    )}
                                    </Row>
                                </Collapse >
                                
                                    
                            </div>
                        </Col>


                        <Col xs={12}>
                            <div className="area-colapsada detalhes-containers">
                                
                                <Button className="btn" onClick={this.handleContainerClick}  >
                                Containers
                                    <span id={`icon-container-abrir${ this.props.id }`}><IconeSetaDescer /></span>
                                    <span id={`icon-container-fechar${ this.props.id }`} hidden><IconeSetaSubir /></span>
                                </Button>
                                
                                <Collapse  isOpen={this.state.container}>
                                    {this.props.data.containers.map((containerItem, x)=>
                                    <Row className={`no-gutters ${ x%2==0 ? "bg-colored" : "" }`}>
                                        {this.props.containerAgendados.map((col, x) =>

                                            <Col key={x} xs={col.tamanhoCol > 2 ? 12 : 6} className="">
                                                <div className="card-detalhe">
                                                    <div>
                                                        <h5>{col.titulo}</h5>
                                                        {/* <div className="desc">{col.field}</div> */}
                                                        <div className="desc">{ 
                                                            col.field == "Container" ?
                                                            (<Link to={`/containers-detalhes/${containerItem[col.field]}`}>{ containerItem[col.field] }</Link>)
                                                            :
                                                            (col.formatacao ?
                                                                col.formatacao(containerItem[col.field])    
                                                            :
                                                                containerItem[col.field] 
                                                            )
                                                        }</div>

                                                    </div>
                                                    
                                                </div>
                                            </Col>

                                        )
                                        }
    
                                    </Row>
                                    )}

                                </Collapse >
                                
                                    
                            </div>
                        </Col>




{/* (col.dataField === "booking.Status" ?
                            
                        : */}
                    </Row>
               </div>
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/booking/components/CardBooking.js